import { Row, Text } from '~/commonComponents';
import CloseIcon from '~/images/icons/CloseIcon';
import { Colors } from '~/themes/colors';

interface IProcedurePillProps {
  label: string;
  onRemove: () => void;
}

export const ProcedurePill = ({ label, onRemove }: IProcedurePillProps) => {
  return (
    <Row
      data-testid="procedure-pill"
      alignItems="center"
      gap={8}
      style={{
        backgroundColor: Colors.primary_50,
        border: `1.5px solid ${Colors.secondary_500}`,
        borderRadius: 36,
        height: 38,
        padding: '0px 12px',
        animation: 'pillFadeIn 0.25s ease-out',
      }}
    >
      <Text fontSize={16} fontWeight={400} style={{ whiteSpace: 'nowrap' }}>
        {label}
      </Text>
      <Row
        data-testid="remove-procedure"
        onClick={onRemove}
        alignItems="center"
        style={{ cursor: 'pointer' }}
      >
        <CloseIcon color={Colors.secondary_500} width={16} height={16} />
      </Row>
    </Row>
  );
};
